const CLASSES = {
    COMPONENT: '[data-js-background-fade]',
}

export default class BackgroundFade {

    constructor() {
        this.activeLayer = null
        this.fadeContainer = document.createElement('div')
        this.fadeContainer.className = 'background-fade-container'
        document.body.appendChild(this.fadeContainer)

        this.layers = Array.from(document.querySelectorAll(CLASSES.COMPONENT)).map((element) => {
            const color = element.dataset.jsBackgroundFade
            const layerElement = document.createElement('div')
            layerElement.className = 'background-fade-layer'
            layerElement.style.backgroundColor = color
            this.fadeContainer.appendChild(layerElement)
            return {
                triggerElement: element,
                layerElement: layerElement,
                color: color,
            }
        })


        this.entryObserver = this.registerEntryObserver()
        this.exitObserver = this.registerExitObserver()

        this.layers.forEach(layer => {
            this.entryObserver.observe(layer.triggerElement)
            this.exitObserver.observe(layer.triggerElement)
        })
    }

    registerEntryObserver() {
        const options = {
            root: null,
            rootMargin: '-50% 0px -50% 0px',
            threshold: 0,
        }

        return new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const layerToActivate = this.layers.find(l => l.triggerElement === entry.target)
                    if (layerToActivate) {
                        this.setActiveLayer(layerToActivate)
                    }
                }
            })
        }, options)
    }

    registerExitObserver() {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0,
        }

        return new IntersectionObserver((entries) => {
            entries.forEach(entry => {

                if (!entry.isIntersecting && this.activeLayer && entry.target === this.activeLayer.triggerElement) {

                    this.revertToDefault()
                }
            })
        }, options)
    }


    setActiveLayer(newLayer) {
        if (newLayer === this.activeLayer) {
            return
        }




        if (this.activeLayer && this.activeLayer.color === newLayer.color) {
            this.activeLayer = newLayer
            return
        }


        if (this.activeLayer) {
            this.activeLayer.layerElement.classList.remove('is-visible')
        }

        this.activeLayer = newLayer
        this.activeLayer.layerElement.classList.add('is-visible')
        this.updateLuminance(this.activeLayer.color)
    }

    revertToDefault() {
        if (this.activeLayer) {
            this.activeLayer.layerElement.classList.remove('is-visible')
            this.activeLayer = null
        }
        document.body.classList.remove('background-light', 'background-dark')
    }

    updateLuminance(color) {
        const rgb = this.colorToRGB(color)
        if (!rgb) return

        const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255
        if (luminance > 0.5) {
            document.body.classList.add('background-light')
            document.body.classList.remove('background-dark')
        } else {
            document.body.classList.add('background-dark')
            document.body.classList.remove('background-light')
        }
    }

    colorToRGB(c) {
        if (!c) return null
        if (c.startsWith('#')) {
            let hex = c.slice(1)
            if (hex.length === 3) {
                hex = hex.split('').map(char => char + char).join('')
            }
            if (hex.length !== 6) return null
            const bigint = parseInt(hex, 16)
            return { r: (bigint >> 16) & 255, g: (bigint >> 8) & 255, b: bigint & 255 }
        } else if (c.startsWith('rgb')) {
            const parts = c.match(/\d+/g)
            if (!parts || parts.length < 3) return null
            return { r: parseInt(parts[0]), g: parseInt(parts[1]), b: parseInt(parts[2]) }
        }
        return null
    }

    tearDown() {
        if (this.entryObserver) this.entryObserver.disconnect()
        if (this.exitObserver) this.exitObserver.disconnect()

        this.revertToDefault()
        if (this.fadeContainer) {
            this.fadeContainer.remove()
        }
    }
}

export const BackgroundFadeComponent = {
    name: 'BackgroundFade',
    componentClass: 'body',
    Source: BackgroundFade,
}